import React, { useEffect, useState } from 'react'
import Page from './components/Page'
import { useParams } from 'react-router-dom'
import Breadcrumbs, { IBreadcrumb } from '../components/Breadcrumbs'
import { EmptyItemModel, IItemModel } from '../features/items/ItemsApp'
import { Skeleton } from '@mui/material'
import ViewSingleItemPage from '../features/items/ViewSingleItemPage'
import { useReturnSingleItemByUniqueId } from '../features/items/itemsSlice'
import { useReturnRouterPrevPage } from '../features/router/routerSlice'
import { useReturnSingleWarehouse } from '../features/warehouses/warehousesSlice'
import ProtectedPage from '../features/router/ProtectedPage'
import OnlyAuthorizedMessage from '../components/OnlyAuthorizedMessage'
import { IPageHeadSectionActionButton, PageHeadSectionActionButton } from '../features/admin/components/PageHeadSection'
import { useReturnCurrentUser } from '../features/user/userSlice'

interface IProps {
    isPublic?: boolean
}

/**
 * Only for authorized users
 */
const SingleItemPrivatePage: React.FC<IProps> = ({ ...props }) => {

    const { isPublic } = props

    const params = useParams()
    const uniqueId: string = params.unique_id ? params.unique_id : ""

    // const [item, setItem] = useState<IItemModel>(EmptyItemModel)
    const item = useReturnSingleItemByUniqueId(uniqueId)
    const [loading, setLoading] = useState<boolean>(true)

    const prevRouterPage = useReturnRouterPrevPage()
    const isPrevWarehousePage = prevRouterPage ? prevRouterPage.replace(/\/\d+$/, "") === "/warehouses" ? true : false : false

    const [customHeadBoxActionButtons, setCustomHeadBoxActionButtons] = useState<IPageHeadSectionActionButton[]>([])

    const getIdFromPathLink = () => {
        const path = prevRouterPage ? prevRouterPage : ""
        const match = path.match(/\/(\d+)$/)
        const id = match ? match[1] : 0

        return Number(id)
    }

    const warehouse = useReturnSingleWarehouse(getIdFromPathLink())
    const user = useReturnCurrentUser()

    /**
     * Breadcrumbs
     */
    const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumb[]>([])

    useEffect(() => {
        if (item.id){
            setLoading(false)
        }

        console.log("item", item)
    }, [item])

    useEffect(() => {
        if (isPrevWarehousePage){
            setBreadcrumbs([
                {
                    title: "Home",
                    link: "/"
                },
                {
                    title: "Warehouses",
                    link: "/warehouses"
                },
                {
                    title: warehouse.title ? warehouse.title : "Warehouse",
                    link: prevRouterPage ? prevRouterPage : ""
                },
                {
                    title: item.title,
                },
            ])
        }else{
            setBreadcrumbs([
                {
                    title: "Home",
                    link: "/"
                },
                {
                    title: "Inventory",
                    link: "/items"
                },
                {
                    title: item.title,
                },
            ])
        }

    }, [item, prevRouterPage])

    useEffect(() => {
        if (user.is_superuser){
            setCustomHeadBoxActionButtons([
                {
                    icon: "edit",
                    variant: "text",
                    link: `/panel/items/edit/${item.id}`,
                    label: "edit",
                    color: "success"
                }
            ])
        }
    }, [user])

    return(
        <Page>
            <div className="single-inventory-item-page-container content-section-wrapper page-container-wrapper">
                
                {customHeadBoxActionButtons.length > 0 && (
                        <div className="action-box-of-admin-base-page-head-section-container">
                            <div className="content-of-action-box-of-admin-base-page-head-section-container">

                                {customHeadBoxActionButtons.map((button, index) => <PageHeadSectionActionButton {...button} key={index} notRouterLink />)}

                            </div>
                        </div>
                )}

                <div className="page-container-head-box">
                    <div className="content-of-page-container-head-box">
                        <h1>{loading ? <Skeleton variant="text" width={150} /> : item.title}</h1>

                        {loading ? (
                            <>
                                <Skeleton variant="text" width={50} />
                            </>
                        ): <Breadcrumbs breadcrumbs={breadcrumbs} />}
                    </div>
                </div>

                {isPublic && <div className="only-auth-message-wrapper"><OnlyAuthorizedMessage /></div>}

                <div className="inventory-list">
                    <ViewSingleItemPage useUniqueId disablePageHeadSection usePublicDetails={isPublic} />
                </div>

            </div>
        </Page>
    )
}

/**
 * Public page
 */
const SingleItemPublicPage = () => {
    return <SingleItemPrivatePage isPublic />
}

/**
 * Page
 */
export default function SingleItem() {

    return(
        <ProtectedPage isAdminOnly={false} redirectIfUnauthorized={false} CustomErrorPage={SingleItemPublicPage}>
            <SingleItemPrivatePage />
        </ProtectedPage>
    )
}